export enum CapacityChangeStatus {
    DELETED = 'DELETED',
    CREATED = 'CREATED',
    UPDATED = 'UPDATED'
}
